module.exports = __webpack_public_path__ + "img/HF.caae475e.png";